import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyChoicesQuestionNameParamsInput } from "shared/api/types/society/[societyId]/choices/[questionName]/index";
import { type SocietyChoicesQuestionNameBodyInput } from "shared/api/types/society/[societyId]/choices/index";
import { type SocietyCustomChoiceDto } from "shared/mappers/database/society-custom-choices/societyCustomChoice";
import { type SocietyCustomQuestionView } from "shared/mappers/database/society-custom-choices/societyCustomQuestion";

export const getSocietyChoicesQuestionNameContract: BaseApiContract<
  SocietyChoicesQuestionNameParamsInput,
  undefined,
  PaginatedResults<SocietyCustomChoiceDto>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/choices/[questionName]",
  paramsType: {} as SocietyChoicesQuestionNameParamsInput,
  responseType: {} as PaginatedResults<SocietyCustomChoiceDto>,
};

export const putSocietyChoicesQuestionNameContract: BaseApiContract<
  SocietyChoicesQuestionNameParamsInput,
  SocietyChoicesQuestionNameBodyInput,
  SocietyCustomQuestionView
> = {
  method: HttpMethod.PUT,
  apiRoute: "/api/v1/society/[societyId]/choices/[questionName]",
  paramsType: {} as SocietyChoicesQuestionNameParamsInput,
  bodyType: {} as SocietyChoicesQuestionNameBodyInput,
  responseType: {} as SocietyCustomQuestionView,
};

export const deleteSocietyChoicesQuestionNameContract: BaseApiContract<
  SocietyChoicesQuestionNameParamsInput,
  undefined,
  void
> = {
  method: HttpMethod.DELETE,
  apiRoute: "/api/v1/society/[societyId]/choices/[questionName]",
  paramsType: {} as SocietyChoicesQuestionNameParamsInput,
  responseType: undefined as unknown as any,
};
